import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { System } from '@app/core/resources/system';
import { PlatformBrowserService } from '@app/core/services/platform-browser.service';

@Component({
    selector: 'app-system-activity-card',
    templateUrl: './system-activity-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./system-activity-card.component.scss']
})
export class SystemActivityCardComponent implements OnChanges {
    @Input() public system: System = new System();
    public data_card_model: Array<{ [property: string]: any }> = [];
    public selectedIndex: number = 0;
    public changeSystem: boolean = false;
    public dataMonth: any = [];
    public dataWeekDay: any = [];
    private weekDay: Array<string> = ['Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab', 'Dom'];
    private month: any = [];
    private valueWeekDay: Array<string> = [];
    private valueMonth: Array<string> = [];

    public constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private router: Router,
        private browserService: PlatformBrowserService
    ) {}

    public ngOnChanges(): void {
        if (!this.browserService.isBrowser) {
            return;
        }
        this.dataWeekDay = [];
        this.dataMonth = [];
        this.parseDataActivity();
        this.setDayToMonth();
        this.dataWeekDay = this.setDataByWeekday(this.valueWeekDay, this.weekDay);
        this.dataMonth = this.setDataByWeekday(this.valueMonth, this.month);
        this.setMovementSystem();
        this.router.events.subscribe((urlNavigate) => {
            if (urlNavigate instanceof NavigationEnd) {
                this.changeSystem = true;
            }
        });
        this.changeDetectorRef.markForCheck();
    }

    private setMovementSystem(): void {
        this.data_card_model = [
            {
                icon_name: 'person',
                text: `Usuarios`,
                value: this.system.relationships.system_information.data[0]?.attributes.qty_user_per_system
            },
            {
                icon_name: 'shopping_cart',
                text: `Pedidos exitosos en 10 días`,
                value: this.system.relationships.system_information.data[0]?.attributes.qty_sent_transaction
            },
            {
                icon_name: 'paid',
                text: `Transferencias coordinadas en 30 días`,
                value: this.system.relationships.system_information.data[0]?.attributes.qty_coordinated_transaction
            }
        ];
    }

    private parseDataActivity(): void {
        this.valueWeekDay = this.system.relationships.system_information.data[0]?.attributes.trend_by_weekday.split(',');
        this.valueMonth = this.system.relationships.system_information.data[0]?.attributes.trend_by_day.split(',');
    }

    private setDayToMonth(): void {
        let monthNow: number = new Date().getMonth();
        let fullYear: number = new Date().getFullYear();
        this.month = [];
        if (this.month.length === 0) {
            for (let i: number = 1; i < 32; i++) {
                this.month.push(new Date(fullYear, monthNow, i).getTime());
            }
            this.month = [].concat(this.month);
        }
    }

    private setDataByWeekday(value: Array<string>, arrayRange: Array<any>): any {
        let dataArray: any = [];
        let auxRange: string = arrayRange.length > 7 ? 'date' : 'category';
        if (value === undefined) {
            return;
        }
        for (let i: number = 0; i < arrayRange.length; i++) {
            dataArray.push({
                [auxRange]: arrayRange[i],
                value: parseInt(value[i], 10)
            });
        }

        return (dataArray = [].concat(dataArray));
    }
}
